{
  "instances": {
    "env": {
      "label": "Umgebungskonfiguration",
      "manager": "Umgebungskonfiguration anpassen",
      "active_profile": "Profil",
      "context_refresh": "Kontext neu laden",
      "bus_refresh": "Spring Cloud Bus-refresh",
      "bus_refresh_success": "Spring Cloud Bus Refresh erfolgreich!",
      "bus_refresh_failure": "Fehlgeschlagen: Konnte Spring Cloud Bus Refresh nicht ausführen!",
      "bus_refresh_title": "Sendet eine Refresh Message an den konfigurierten Spring Cloud Bus, der eine Refresh Message an alle verbundenen Nodes sendet",
      "context_refresh_failed": "Fehlgeschlagen",
      "context_refreshed": "Erfolreich!",
      "context_reset": "Zurücksetzen",
      "context_reset_failed": "Fehlgeschlagen",
      "context_resetted": "Zurückgesetzt",
      "context_update": "Aktualisieren",
      "context_update_failed": "Fehlgeschlagen",
      "context_updated": "Aktualisiert",
      "no_properties": "Keine Eigenschaften gesetzt",
      "refresh": "Umgebungskonfiguration neu laden",
      "application": "Anwendung",
      "instance": "Instanz",
      "refreshed_configurations": "Aktualisierte Konfigurationen:"
    }
  }
}
